export function getAllCountry(axiosPrivate, params){
  const queryParams = new URLSearchParams()
  queryParams.append('hs_vr', String(params.hs_vr))
  queryParams.append('year', String(params.year))
  queryParams.append('source_type', String(params.source_type))
  
  return axiosPrivate.get(`/trade-data-management/list-country?${decodeURIComponent(queryParams.toString())}`)
}